import { useContext, useState } from "react"
import { AuthContext } from "../contexts/auth"
import postService from "../services/postService"
import toast from "react-hot-toast"
import getServices from "../services/getServices"
import putService from "../services/putService"

const useTemplateListaState = () => {

    const { signOut } = useContext(AuthContext)

    const [nomeLista, setNomeLista] = useState('')
    const [descricaoOpcao, setDescricaoOpcao] = useState('')
    const [lista, setLista] = useState([])    

    const [submit, setSubmit] = useState(false)
    const [listaObjeto, setListaObjeto] = useState(null)

    const _getLista = async (_id) =>{
        
        setNomeLista('')

        if (submit){
            return;
        }

        setSubmit(true)
        let result = await getServices(`admin/templatelista/${_id}/`)
        if (result.type === 'success'){
            setNomeLista(result.data.nome)

            if (result.data.opcoes && result.data.opcoes !==''){
                setListaObjeto(result.data)
                let _lista = JSON.parse(result.data.opcoes)
                setLista(_lista)

            }
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)        
    }

    const _salvarLista = async (json, closeModal)=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let nome_lista = false;
        
        if (nomeLista !== '') {
            nome_lista = true;
        } else {
            toast.error('O campo nome da lista não pode ser em branco.')
        }
        
        if (nome_lista){
            let result = null
            if (listaObjeto?.id) {

                let putJson = {
                    ...listaObjeto,
                    nome: json.nome,
                    opcoes: json.opcoes,
                }
                result = await putService(`admin/templatelista/${listaObjeto?.id}/`,putJson)
            }
            else {
                result = await postService('admin/templatelista/',json)
            }
            if (result.type === 'success'){
                if (result.data?.status){
                    result.data?.status.forEach((mensagem)=>{
                        toast.error(mensagem)
                    })
                }
                else{
                    closeModal()
                }
                setLista([])
                setNomeLista('')
            }
            else if (result.data?.code === 'token_not_valid'){
                signOut()
            }
        }
        setSubmit(false)        
    }
  
    return {
        getLista : {value: submit, set: _getLista},
        salvarLista : {value:submit, set: _salvarLista},
        nomeLista: {value: nomeLista, set:setNomeLista},
        descricaoOpcao: {value: descricaoOpcao, set:setDescricaoOpcao},
        lista: {value: lista, set:setLista},
    }
}

export default useTemplateListaState